import React from 'react';
import { css } from '@emotion/react';
import { Paper, Card, CardContent, Box, Button } from '@mui/material';
import LegalSign from './LegalSign';
import PolicyIcon from '@mui/icons-material/Policy';
import CorporateFareIcon from '@mui/icons-material/CorporateFare';
import PhoneAndroidIcon from '@mui/icons-material/PhoneAndroid';
import MapIcon from '@mui/icons-material/Map';
import CardHeaderCD from '../component/CardHeaderCD';
import LegalListGroup from './LegalListGroup';
//import {  } from '@mui/icons-material';
import { useHistory } from 'react-router-dom';
import { useGetOrgInfo } from './useGetOrgInfo';
import LabelValueCD from '../component/LabelValueCD';
const wrapStyle = css({
	display: 'flex',
	flexDirection: 'column',
	flex: 1,
	padding: '16px'
});

const OrganizationInfo = ({
	full_name,
	address_1,
	address_2,
	city,
	state,
	zip,
	phone,
	fax
}) => (
	<Box sx={{ p: 2 }}>
		<LabelValueCD
			label="Name"
			value={full_name}
			Icon={CorporateFareIcon}
			iconColor="secondary"
		/>
		<LabelValueCD label="Address" value={address_1} Icon={MapIcon} />
		<LabelValueCD label="City" value={city} Icon={MapIcon} />
		<LabelValueCD label="State" value={state} Icon={MapIcon} />
		<LabelValueCD label="Zip" value={zip} Icon={MapIcon} />
		<LabelValueCD label="Phone" value={phone} Icon={PhoneAndroidIcon} />
		<LabelValueCD label="Fax" value={fax} Icon={PhoneAndroidIcon} />
	</Box>
);

const Legal = ({ match }) => {
	const history = useHistory();
	const { params } = match;
	const contractID = params?.contractID ?? 0;
	const hasContractID = !!contractID;
	const { data } = useGetOrgInfo();

	return (
		<Paper css={wrapStyle} elevation={2}>
			{!hasContractID && (
				<>
					<Card sx={{ mb: 2 }}>
						<CardHeaderCD title="LEGAL AGREEMENTS" />
						<CardContent
							sx={{
								display: 'flex',
								gap: '8px',
								alignItems: 'center'
							}}>
							<PolicyIcon sx={{ fontSize: '64px' }} />

							<Box>
								You can view and sign legal agreements for your
								organization online.
							</Box>
						</CardContent>
					</Card>
					<Card>
						<CardHeaderCD title="ORGANIZATION INORMATION" />
						<CardContent
							sx={{
								display: 'flex',
								flexDirection: 'column',
								alignItems: 'center'
							}}>
							<Box
								sx={{
									display: 'flex',
									alignItems: 'center'
								}}>
								<CorporateFareIcon
									sx={{ fontSize: '64px', mb: 2, mr: 1 }}
								/>
								<Box>
									Make sure the organization information is
									correct before accepting online agreements.
								</Box>
							</Box>
							<Box
								sx={{
									display: 'flex',
									flexDirection: 'column',
									alignSelf: 'stretch'
								}}>
								<OrganizationInfo {...data} />
							</Box>
							<Button
								variant="outlined"
								onClick={() =>
									history.push(
										'/account/personal/organization'
									)
								}>
								UPDATE
							</Button>
						</CardContent>
					</Card>
				</>
			)}

			{!hasContractID && <LegalListGroup />}
			{hasContractID && (
				<LegalSign
					contractID={contractID}
					listStyle={css({ flex: 1 })}
				/>
			)}
		</Paper>
	);
};
export default Legal;
